<template>
  <div>
    <Breadcrumbs primary="Системные отчеты" secondary="Журнал событий"/>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card no-top-body-padding no-border">
          <EventLogReport
              download-report-url="/reports/downloadEventLogReport"
              get-report-url="/reports/eventLogReport"
              :mutate-params="injectTaskId"
          >
            <template #client-extension>
              <el-form-item label="Рассылка" >
                <el-select v-model="searchTask" class="full-width" filterable>
                  <el-option label="Любая" value=""></el-option>
                  <el-option
                      v-for="(task, key) in tasks"
                      :key="key"
                      :label="task.name"
                      :value="task._id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </EventLogReport>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EventLogReport from "@shared/components/reports/event-log/event-log.component"

export default {
  name: "EventLog",
  title: "Журнал событий",
  components: {EventLogReport},
  methods: {
    injectTaskId(payload){
      payload.taskId = this.searchTask
      return payload
    }
  },
  computed: {
    tasks() {
      return this.$store.getters.allTasks
    },
  },
  data(){
    return {
      searchTask: ""
    }
  }
}

</script>